import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import { companyManagementUrl } from "../../../config";
import { branchFields } from "../../../data/DynamicTable/CompanyManagementForms";
import { allCompanies, allRegions } from "../../../data/Axios/queries";

const base_url = companyManagementUrl.uri;

const BranchForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const initialValues = {
    branchName: props.data ? props.data.branchName : "",
    createdDate: props.data ? props.data.createdDate : new Date().toISOString(),
    createdBy: props.data ? props.data.createdBy : userId,
    updatedBy: userId,
    updatedDate: new Date().toISOString(),
    companyId: props.data ? props.data.companyId : companyId,
    company: props.data ? props.data.company : "",
    regionId: props.data ? props.data.regionId : "",
    region: props.data ? props.data.region : "",
    location: props.data ? props.data.location : "",
    building: props.data ? props.data.building : "",
    contacts: props.data ? props.data.contacts : "",
isWarehouse: props.data ? Number(props.data.isWarehouse) === 1 : false,
  };

  const [companyData, setCompanyData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const companyDataResponse = await graphqlQuery(allCompanies, base_url);
        if (companyDataResponse) setCompanyData(companyDataResponse);
        const regionDataResponse = await graphqlQuery(allRegions, base_url);
        if (regionDataResponse) setRegionData(regionDataResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  const regionOptions = regionData.map((region) => ({
    value: region.id,
    label: region.regionName,
  }));

  const fields = [
    ...branchFields,
      {
        name: "location",
        label: "Location *",
        type: "text",
        gridColumn: "span 2",
        required: true,
      },
      {
        name: "building",
        label: "Building Name *",
        type: "text",
        gridColumn: "span 2",
        required: true,
      },
      {
        name: "contacts",
        label: "Branch Contacts *",
        type: "text",
        gridColumn: "span 2",
        required: true,
      },
    {
      name: "regionId",
      label: "Region",
      type: "select",
      gridColumn: "span 2",
      options: regionOptions,
      required: true,
    },
    {
      name: "isWarehouse",
      label: "Is Branch a Warehouse?",
      type: "checkbox", // isWarehousecheckbox field
      gridColumn: "span 2",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const { branchName, companyId, regionId, isWarehouse, location, building, contacts } = values;

    // Convert boolean to integer
    const warehouseValue = isWarehouse ? 1 : 0;

    const mutationData = props.isEditing
      ? {
          id: props.data.id,
          branchName,
          companyId,
          regionId,
          isWarehouse: warehouseValue,
          updatedBy: userId,
          location,
          building,
          contacts
        }
      : {
          branchName,
          companyId,
          regionId,
          isWarehouse: warehouseValue,
          createdBy: userId,
          location,
          building,
          contacts
        };

    const response = await generateAndExecuteMutation(
      props.isEditing ? "updateBranch" : "createBranch",
      mutationData,
      "branch",
      base_url
    );

    if (Object.values(response)[0] != null) {
      props.onClose();
      props.onAction();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: `Branch ${
          props.isEditing ? "updated" : "created"
        } successfully.`,
      });
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "An error occurred while processing your request. Please try again later.",
    });
  }

  setSubmitting(false);
};


  if (loading) return <div className="justify-content-center">Loading...</div>;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Branch" : "Create Branch"}
      subtitle={
        props.isEditing ? "Edit an Existing Branch" : "Create a New Branch"
      }
    />
  );
};

export default BranchForm;
